import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import Styles from './HeaderSignup.css'
import config from '../../config'
import { LinkIcon } from '../../components'
// import convert from '../../helpers/convert'
// import ReactTooltip from 'react-tooltip'
// import format from '../../helpers/format'

@CSSModules(Styles, {allowMultiple:true})
export default class HeaderSignup extends Component {
  constructor(props){
    super(props)
  }
  render() {
    return (
      <div styleName={'hidden-xs form-wrap'}>
        <form styleName='form'
          acceptCharset='UTF-8'
          method='post'
          action={config.signupForm.url}
          target='signup_confirmation'
          ref={(el) => this.myFormRef = el}>
          <input styleName='input'
            name={config.signupForm.id}
            type='email'
            placeholder='Get email updates'
            required />
          <div style={{
            position: 'absolute',
            left: '-9999px',
            top: '-9999px',
          }}>
            <label htmlFor="pardot_extra_field">Comments</label>
            <input type="text" id="pardot_extra_field" name="pardot_extra_field" />
          </div>
          <button styleName='submit'
            type='submit'>
              Sign up<LinkIcon faclass='fa-envelope-o' />
            </button>
        </form>
      </div>
    )
  }
}

